import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetLengthReportStageAndReportingPhase = createAsyncThunk(
  "ReportingPhase/GetLengthReportStageAndReportingPhase",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/ReportStage/GetLengthReportStageAndReportingPhase",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const ReportingPhaseReducer = createSlice({
  name: "ReportingPhaseReducer",
  initialState: {

    ReportingPhase: {},
    loadingReportingPhase: false,
    errorReportingPhase: null,

  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetLengthReportStageAndReportingPhase.pending, (state, action) => {
        state.loadingReportingPhase = true;
        state.ReportingPhase = action.payload;
        state.ReportingPhase = null;
      })
      .addCase(GetLengthReportStageAndReportingPhase.fulfilled, (state, action) => {
        state.loadingReportingPhase = false;
        state.ReportingPhase = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetLengthReportStageAndReportingPhase.rejected, (state, action) => {
        state.loadingReportingPhase = false;
        state.errorReportingPhase = action.payload;
      })
     
  },
});

export default ReportingPhaseReducer.reducer;
